import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-profile-component',
  templateUrl: './profile-component.component.html',
  styleUrls: ['./profile-component.component.scss'],
})
export class ProfileComponentComponent implements OnInit {
  userName: any;
  urlPosition: any = '';
  plans = ['Free Plan'];
  plan: string;
  companyList: any;

  constructor(
    private loginSignupService: LoginSignupService,
    private localStorage: LocalStorageService,
    private router: Router,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.userName = this.loginSignupService.getUserSession().user.name;
    this.plan = this.loginSignupService.getUserSession().user.plan;
    this.urlPosition = this.router.url;
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.urlPosition = this.router.url;
      }
    });
  }

  logout() {
    this.companyList = JSON.parse(
      this.localStorage.getItem('compareCompanyList')
        ? this.localStorage.getItem('compareCompanyList')
        : '[]'
    );
    this.companyList.forEach((element) => {
      this.commonService.addToCompareList(element);
    });
    this.loginSignupService.userLogoutAPI();
    this.loginSignupService.socialLogout();
    this.router.navigate(['/']);
  }
}
